<template>
<div class="p-6 mb-15 shadow-md bg-light rounded-md">
    <div class="flex justify-between items-start">
        <h3 v-if="title !== ''" class="font-bold text-3xl dark:text-gray-200 pr-6">{{ title }}</h3>
        <p class="text-lg underline cursor-pointer" @click="toggleOpen">
            {{ open ? 'Close' : 'Open' }}
        </p>
    </div>
    <div v-show="open">
        <slot name="description"></slot>
        <slot name="instructions"></slot>

        <div class="flex justify-center mt-10" v-if="instructions && instructions.length > 1">
            <button
                v-for="(button, index) in instructions"
                class="w-5 h-5 mx-0.5 border-2 border-dark rounded-full"
                :class="index === currentElementIndex ? 'bg-dark' : ''"
                :key="'button' + index"
                @click.prevent="showElement(index)" />
        </div>
    </div>
</div>
</template>

<script>
import { ref } from 'vue'
import Button from "@/Jetstream/Button";

export default {
    name: "SuperAdminInstructions",
    components: { Button },
    props: {
        title: {
            type: String
        },
        instructions: {
            type: Array,
        }
    },
    emits: ['showElement'],
    setup(props, { emit }) {
        const open = ref(true);
        const toggleOpen = () => {
            open.value = !open.value;
        };

        const currentElementIndex = ref(0);
        const showElement = (elementIndex) => {
            currentElementIndex.value = elementIndex;
            emit('showElement', currentElementIndex.value);
        }

        return {
            open,
            toggleOpen,
            currentElementIndex,
            showElement,
        }
    },
}
</script>

<style scoped>

</style>
